export enum OkaneServiceNameEnums {
    OMS_PAY = 'oms-pay',
    STAR_CLEANER_PAY = "star-cleaner-pay"
}
